// Decide se o clique em uma célula deve disparar o onRowClick da grid.
//
// Por padrão a linha inteira é clicável (comportamento histórico do CustomGrid).
// Com `clickableCellsOnly` ligado, só as colunas marcadas com `clickable: true`
// navegam — as demais células ficam inertes (e sem cursor de ponteiro).
export function isCellClickable({ hasRowClick, clickableCellsOnly, column }) {
  if (!hasRowClick) return false;
  if (!clickableCellsOnly) return true;
  return !!(column && column.clickable);
}

export default isCellClickable;
